
<!--
<div>
    <pre>{{user | json}}</pre>
</div>
-->

<div class="container-fluid mt-4">
    <div class="row">
        <div class="col-6">
            <div class="card">
                <div class="card-header">
                    <div class="card-title">
                        Profile
                    </div>
                </div>

                <div class="card-body">
                    <h4>{{user?.firstName}} {{user?.lastName}}</h4>
                    <div>{{user?.email}}</div>
                    <div>{{user?.role}}</div>
                </div>
            </div>

        </div>
    </div>
</div>

